<template>
  <div>
  <b-modal
    title="墊繳"
    size="lg"
    centered
    hide-footer
    header-class="head-modal"
    v-model="modalShow"
  >
    <tables-page
      :tableData="table_data"
      :tableFields="table_fields"
    >
      <template #cell(start_date)="row">
        {{ convertRocDate(row.item.start_date) }}
      </template>

      <template #cell(end_date)="row">
        {{ convertRocDate(row.item.end_date) }}
      </template>
    </tables-page>
  </b-modal>
</div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import { convertRocDate } from "@/models/HELPERS/common.js";

export default {
  name: 'PaymentModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  components: {
    TablesPage
  },
  data () {
    return {
      table_fields: [
        {
          key: "number",
          label: "會員編號",
        },
        {
          key: "member_name",
          label: "會員姓名",
        },
        {
          key: "start_date",
          label: "開始",
        },
        {
          key: "end_date",
          label: "結束",
        }
      ],
      page: {},
      table_data: [],
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) this.mapTableData();
      },
      immediate: false
    }
  },
  methods: {
    convertRocDate,
    // 重組表格資料
    mapTableData() {
      if (this.data.behalf_history) {
        const list = this.data.behalf_history.split(',');

        this.table_data = list.map(item => {
          const start_date = item.split('~')[0];
          const end_date = item.split('~')[1];

          return {
            number: this.data.number,
            member_name: this.data.member_name,
            start_date: start_date,
            end_date: end_date
          }
        })
      } else {
        this.table_data = [];
      }
    },
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/PaymentModal.vue